import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import { ExportTypeType } from 'src/types/table';
import ExportTableAction from 'src/components/ExportTableAction';
import TopBlockAdmin from '../AdminContainer/TopBlock';

type TopBlockProps = {
    reloadApplicationStatusMessagesList: () => void;
    permissionCreate: boolean;
    handleExport: (type: ExportTypeType) => void;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleNew = () => {
        navigate(`/admin/application_status_messages/new`);
    };

    return (
        <>
            <TopBlockAdmin
                actions={[
                    {
                        node: (
                            <ExportTableAction
                                title={translate('applicationStatusMessages.action.exportFile')}
                                handleExport={props.handleExport}
                            />
                        ),
                    },
                    {
                        onClick: props.reloadApplicationStatusMessagesList,
                        icon: <ReloadIcon />,
                        tooltip: translate('applicationStatusMessages.action.synchronizeTable'),
                        variant: 'outlined',
                    },
                    {
                        label: translate('applicationStatusMessages.action.createNew'),
                        onClick: handleNew,
                        icon: <AddIcon />,
                        hidden: !props.permissionCreate,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
